import { NavLink } from 'react-router-dom'

export type SidebarItem = {
  label: string
  href: string
}

type Props = {
  items: SidebarItem[]
}

export function SectionSidebar({ items }: Props) {
  return (
    <nav style={{ width: 180, flexShrink: 0 }}>
      {items.map((item) => (
        <NavLink
          key={item.href}
          to={item.href}
          end
          style={({ isActive }) => ({
            display: 'block',
            padding: '7px 12px',
            borderRadius: '8px',
            textDecoration: 'none',
            color: isActive ? 'var(--p-color-text-emphasis)' : 'var(--p-color-text)',
            background: isActive ? 'var(--p-color-bg-surface-selected)' : 'transparent',
            fontWeight: isActive ? 600 : 400,
            fontSize: '14px',
            marginBottom: 2,
          })}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
